"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSurface = exports.surfaceRuleSet = void 0;
const typeguard_1 = require("../types/typeguard");
exports.surfaceRuleSet = {
  width: typeguard_1.isNumber,
  height: typeguard_1.isNumber,
  min_resolution: typeguard_1.isNumber,
  bleed: value => value ? (0, typeguard_1.isNumber)(value) || Array.isArray(value) && value.every(typeguard_1.isNumber) : true,
  safeOffset: (0, typeguard_1.optional)(typeguard_1.isNumber),
  customShapeSvg: (0, typeguard_1.optional)(typeguard_1.isString)
};
const isSurface = s => (0, typeguard_1.isType)(s, exports.surfaceRuleSet);
exports.isSurface = isSurface;